import { Variant } from "@/types";
import { BuilderBlock, isEditing } from "@builder.io/sdk-react";

const DEFAULT_INDEX = "default";

type BlocksToRenderReturnType = {
  blocks: BuilderBlock[];
  path: string;
  index: number | typeof DEFAULT_INDEX;
};

/**
 * Taken with minor modifications which removes hydration checks from Builder SDK here: https://github.com/BuilderIO/builder/blob/94f800308672b7da5422705eb83aa9629f5c6098/packages/sdks/src/blocks/personalization-container/helpers.ts#L98
 */
export const getBlocksToRender = ({
  variants,
  previewingIndex,
  fallbackBlocks,
  filteredVariants,
}: {
  variants?: Variant[];
  previewingIndex?: number | null;
  fallbackBlocks?: BuilderBlock[];
  filteredVariants?: Variant[];
}): BlocksToRenderReturnType => {
  const fallback: BlocksToRenderReturnType = {
    blocks: fallbackBlocks ?? [],
    path: "this.children",
    index: DEFAULT_INDEX,
  };

  if (isEditing()) {
    // If editing a specific variant
    if (
      typeof previewingIndex === "number" &&
      previewingIndex < (variants?.length ?? 0)
    ) {
      const variant = variants?.[previewingIndex];
      if (variant) {
        return {
          blocks: variant.blocks,
          path: `variants.${previewingIndex}.blocks`,
          index: previewingIndex,
        };
      }
    }
    // Otherwise we're editing the default variant
    return fallback;
  }

  const winningVariant = filteredVariants?.[0];
  if (winningVariant && variants) {
    const variantIndex = variants.indexOf(winningVariant);
    if (variantIndex !== -1) {
      return {
        blocks: winningVariant.blocks,
        path: `variants.${variantIndex}.blocks`,
        index: variantIndex,
      };
    }
  }

  return fallback;
};
